import "core-js/modules/es.array.push.js";
import axios from "axios";
import { inject, ref, computed } from "vue";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import { mapActions, mapMutations } from "vuex";
import "swiper/css";
import "swiper/css/navigation";
export default {
  data() {
    return {
      error: false,
      products: [],
      category: null,
      currentPathName: "",
      categoryMap: {
        rolls: "Роллы",
        sushi: "Суши",
        sets: "Сеты",
        snacks: "Боулы",
        drinks: "Напитки",
        rollsq: "Соусы"
      },
      components: [],
      idFirst: 0,
      idLast: 0,
      isLoading: false,
      isLoadingSlides: false,
      signalItem: null,
      signalIngredients: null,
      lastRequestItem: null,
      lastRequestIngredients: null,
      pageSlide: 1,
      pageNumber: 1,
      limitSlide: 4,
      currentPageSlide: 0,
      totalPagesSlide: 0,
      buttonDisabledPrev: computed(() => Number(this.$route.params.id) == this.idFirst),
      buttonDisabledNext: computed(() => Number(this.$route.params.id) == this.idLast)
    };
  },
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    paths() {
      return [{
        name: this.categoryMap[this.category],
        path: `/rol-shop/${this.$route.params.category}`
      }, {
        name: this.currentPathName,
        path: this.$route.params
      }];
    }
  },
  methods: {
    ...mapActions({
      addToFavorite: "favorite/addToFavorite"
    }),
    ...mapMutations({
      setPaths: "crumbs/setPaths"
    }),
    async fetchItems(id) {
      let apiRes = null;
      try {
        this.isLoading = true;
        this.controller = new AbortController();
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/items?id=${id}`, {
          signal: this.controller.signal
        });
        this.product = {
          ...data[0],
          isFavorite: false,
          favoriteId: null,
          isAdded: false,
          count: 1
        };

        // название текущей страницы в хлебных крошках
        this.currentPathName = this.product.title;
      } catch (err) {
        if (err.response) {
          apiRes = err.response.status;
        }
      } finally {
        this.isLoading = false;
        if (apiRes == 404) {
          this.error = true;
          this.$router.push('/rol-shop/404');
        }
        // обновление crumbs
        this.setPaths(this.paths);
      }
    },
    async fetchFavorite() {
      let apiRes = null;
      try {
        const {
          data: favorites
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/favorites`);
        const favorite = favorites.find(favorite => favorite.item_id === this.product.id);
        if (favorite) {
          this.product.isFavorite = true;
          this.product.favoriteId = favorite.id;
        }
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        if (apiRes == 404) {
          this.error = true;
          this.$router.push('/rol-shop/404');
        }
      }
    },
    async fetchIngredients() {
      // остановка запросов перед следующим вызовом функции
      const controller = new AbortController();
      if (this.lastRequestIngredients) {
        this.lastRequestIngredients.abort();
      }
      this.lastRequestIngredients = controller;
      this.signalIngredients = controller.signal;

      // в массив и обработка игредиентов
      if (this.product.composition) {
        let ingredients = this.product.composition.split(",");
        ingredients = ingredients.map(obj => obj.trim());
        let apiRes = null;
        try {
          // очистка массива
          this.components = [];
          for (const ingredient of ingredients) {
            const {
              data: resurs
            } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/components?name=*${ingredient}`, {
              signal: this.signalIngredients
            });
            if (resurs.length > 0) {
              this.components.push(resurs[0]);
            }
          }
        } catch (err) {
          if (err.response) {
            apiRes = err.response.status;
          }
          if (axios.isCancel(err)) {
            console.log(err);
          }
        } finally {
          if (apiRes == 404) {
            this.error = true;
            this.$router.push('/rol-shop/404');
          }
        }
      }
    },
    onClickGoItem(to) {
      const currentId = Number(this.$route.params.id);
      if (to == "next" && currentId < this.idLast) {
        this.$router.push(`/rol-shop/${this.category}/${currentId + 1}`);
      }
      if (to == "prev" && currentId > this.idFirst) {
        this.$router.push(`/rol-shop/${this.category}/${currentId - 1}`);
      }
    },
    async countItemsCategory() {
      try {
        const {
          data: limit
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/items?category=${this.category}&limit=1`);

        // ID первой и последнего товаров в категории
        this.idFirst = limit.items[0].id;
        this.idLast = limit.items[0].id + limit.meta.total_items - 1;
      } catch (err) {
        console.log(err);
      }
    },
    load(id) {
      this.fetchItems(id).then(() => {
        // включение кнопки корзины
        this.cart.some(cartItem => cartItem.id === this.product.id) ? this.product.isAdded = true : null;
        this.fetchFavorite();
        this.fetchIngredients();
      });
    },
    async fetchSlides() {
      try {
        this.isLoadingSlides = true;
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/items?page=${this.pageSlide}&limit=${this.limitSlide}&category=${this.category}`);
        this.slidesTovar = this.slidesTovar.concat(data.items.map(obj => ({
          ...obj,
          isFavorite: false,
          favoriteId: null,
          isAdded: false,
          count: 1
        })));

        // текущая загруженная страница
        this.currentPageSlide = data.meta.current_page;
        this.totalPagesSlide = data.meta.total_pages;
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingSlides = false;
      }
    },
    async fetchFavoriteSlides() {
      try {
        const {
          data: favorites
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/favorites`);
        this.slidesTovar = this.slidesTovar.map(item => {
          const favorite = favorites.find(favorite => favorite.item_id === item.id);
          if (!favorite) {
            return item;
          }
          return {
            ...item,
            isFavorite: true,
            favoriteId: favorite.id
          };
        });
      } catch (err) {
        console.log(err);
      }
    },
    loadSlides() {
      this.fetchSlides().then(() => {
        // включение кнопки для слайдов
        this.slidesTovar = this.slidesTovar.map(item => ({
          ...item,
          isAdded: this.cart.some(cartItem => cartItem.id === item.id)
        }));
        this.fetchFavoriteSlides();
      });
    },
    onSlideChange(direction, swiper) {
      if (direction == "prev") {
        if (this.pageNumber > 1) {
          // текущая страница в слайдере
          this.pageNumber = this.pageNumber - 1;
          swiper.slidePrev();
        }
      }
      if (direction == "next") {
        if (this.pageNumber < this.totalPagesSlide) {
          this.pageNumber = this.pageNumber + 1;
          if (this.pageNumber <= this.currentPageSlide) {
            //  если уже была загружена
            swiper.slideNext();
          } else {
            this.pageSlide = this.pageSlide + 1;
            this.fetchSlides().then(() => {
              // включение кнопки для слайдов
              this.slidesTovar = this.slidesTovar.map(item => ({
                ...item,
                isAdded: this.cart.some(cartItem => cartItem.id === item.id)
              }));
              this.fetchFavoriteSlides();
              // переход
              swiper.slideNext();
            });
          }
        }
      }
    },
    syncFavorite(type, item) {
      if (type == "product") {
        const sliderItem = this.slidesTovar.find(pl => pl.id === this.product.id);
        if (sliderItem) {
          if (!sliderItem.isFavorite) {
            sliderItem.isFavorite = true;
          } else {
            sliderItem.isFavorite = false;
          }
        }
      }
      if (type == "slides") {
        if (item.id == this.product.id) {
          if (!this.product.isFavorite) {
            this.product.isFavorite = true;
          } else {
            this.product.isFavorite = false;
          }
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.category = to.params.category;
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.category = to.params.category;
    // для перехода к другому товару
    this.load(to.params.id);
    next();
  },
  mounted() {
    this.load(this.$route.params.id);
    if (!this.error) {
      this.countItemsCategory();
    }

    // очистка слайдера
    this.slidesTovar = [];
  },
  setup() {
    const prev = ref(null);
    const next = ref(null);
    const {
      product,
      slidesTovar
    } = inject("items");
    const {
      cart,
      addToCart,
      removeFromCart
    } = inject("cart");
    const onClickAddPlus = (item, type) => {
      if (!item.isAdded) {
        addToCart(item);
        // синхрон между товаром и слайдером (корзина)
        if (type == "product") {
          slidesTovar.value.forEach(element => {
            if (element.id == item.id) {
              element.isAdded = true;
            }
          });
        }
        if (type == "slides" && product.value.id === item.id) {
          product.value.isAdded = true;
        }
      } else {
        removeFromCart(item);

        // изменение состояния кнопки товара
        product.value.isAdded = false;
        product.value.count = 1;

        // карточка слайдера
        slidesTovar.value.forEach(pl => {
          if (pl.id === item.id) {
            pl.isAdded = false;
            pl.count = 1;
          }
        });
      }
    };
    return {
      modules: [Navigation],
      product,
      prev,
      next,
      cart,
      onClickAddPlus,
      slidesTovar
    };
  }
};